import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Company } from "src/modules/database/shared/company.model";
import { Objects } from "src/modules/utils/shared/objects";
import { EntityDefinition } from "../../models/entity-definition.model";
import { TableData } from "../../models/table-data.model";
import { TableRow } from "../../models/table-row.model";
import { TableCellType } from "../../netgen/TableCellType";
import { TableColumn } from "../../netgen/TableColumn";
import { AdminBaseListComponent } from "../admin-base-list/admin-base-list.component";

@Component({
    selector: "app-edit-general-companies",
    templateUrl: "../../../sm-base/components/admin-base-list/admin-base-list.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditGeneralCompaniesComponent extends AdminBaseListComponent<Company> {

    static staticDefinition = Objects.fromPlain(EntityDefinition<Company>, {
        type: Company,
        nameKey: "entity.Company.entityName",
        namePluralKey: "entity.Company.entityNamePlural",
        categoryKey: "entity.DatabaseUser.category",
        icon: "fas fa-building",
        apiEndpoint: "api/app/company",        
        adminListUrl: "/base2/admin/editGeneralCompanies"
    });

    definition = EditGeneralCompaniesComponent.staticDefinition;

    getTable(): TableData {
        return new TableData([
            new TableColumn("name", this.app.t("entity.Company.fields.name"), TableCellType.string, 30),
            new TableColumn("sortName", this.app.t("entity.Company.fields.sortName"), TableCellType.string, 30)
        ], this.listData.map(o => new TableRow("", o, {
            name: o.name,
            sortName: o.sortName
        })), ["name"]);
    }
}
